module.exports = __webpack_public_path__ + "static/img/其他.ab90e609.jpg";